import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipIcon } from 'common/components/svgs';
import LeadsPopup from './leadsPopup';

const OngoingLeads = ({ studentId, data }) => {
  const { t } = useTranslation();
  const length = data?.length || 0;
  const hasOngoingLeads = length > 0;
  const moreThanThree = length > 3;

  const [showPopup, setShowPopup] = useState(false);

  const popupWrapper = useRef();
  const mouseLeaveTimeout = useRef(null);

  const handleMouseEnter = () => {
    if (mouseLeaveTimeout.current) {
      clearTimeout(mouseLeaveTimeout.current);
      mouseLeaveTimeout.current = null;
    }
    setShowPopup(true);
  };

  const handleMouseLeave = () => {
    mouseLeaveTimeout.current = setTimeout(() => {
      setShowPopup(false);
    }, 100);
  };

  const handleClick = e => {
    e.stopPropagation();
    e.preventDefault();
  };

  if (hasOngoingLeads) {
    return (
      <div
        className="ongoing-leads__container"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        ref={popupWrapper}
      >
        <div className="ongoing-leads">
          <div className="ongoing-leads__count">
            {moreThanThree ? '>3' : length}
            {` `}
            {t('cms:cms.students.list.column.ongoing_leads.label')}
          </div>
          <TooltipIcon />
        </div>
        {showPopup && <LeadsPopup studentId={studentId} data={data} wrapper={popupWrapper} />}
      </div>
    );
  }

  return <span>-</span>;
};
export default OngoingLeads;
